import React from 'react'
import utils from './utils'

function getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer) {

    const width = gameContainerWidth
    const height = gameContainerHeight
    let { value_1, value_2 } = quantities
    const colWidth = width / 11
    const fontSize = colWidth
    let numbersLayout = (
        <g>
            {settings.answer_required !== '1' ? <text
                className="level-text-primary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={colWidth}
                y={height / 2}
                textAnchor="middle"
            >{value_1}</text> :
                utils.getOperationSign(
                    colWidth,
                    height / 2,
                    fontSize,
                    'answer'
                )
            }

            {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                colWidth * 2.5,
                height / 2,
                fontSize,
                settings.operation === 'addition' ? 'plus' : 'minus'
            ) : null}

            {settings.answer_required !== '2' ? <text
                className="level-text-primary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={colWidth * 4}
                y={height / 2}
                textAnchor="middle"
            >{value_2}</text> :
                utils.getOperationSign(
                    colWidth * 4,
                    height / 2,
                    fontSize,
                    'answer'
                )
            }

            {utils.getOperationSign(
                colWidth * 5.5,
                height / 2,
                fontSize,
                'equal'
            )}

            {settings.answer_required !== '3' ? <text
                className="level-text-primary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={colWidth * 7}
                y={height / 2}
                textAnchor="middle"
            >{value_2}</text> :
                utils.getOperationSign(
                    colWidth * 7,
                    height / 2,
                    fontSize,
                    'answer'
                )
            }

            {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                colWidth * 8.5,
                height / 2,
                fontSize,
                settings.operation === 'addition' ? 'plus' : 'minus'
            ) : null}

            {settings.answer_required !== '4' ? <text
                className="level-text-primary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={colWidth * 10}
                y={height / 2}
                textAnchor="middle"
            >{value_1}</text> :
                utils.getOperationSign(
                    colWidth * 10,
                    height / 2,
                    fontSize,
                    'answer'
                )
            }
        </g>
    )
    return (
        <svg
            height={height}
            width={width}
        >
            {numbersLayout}
        </svg>
    )
}

function getValues(value_1, value_2, answer, settings) {
    const answerRequired = settings.answer_required || 'answer'
    switch (answerRequired) {
        case '2':
            return settings.show_tens ?
                [utils.getTens(value_1), answer, utils.getTens(value_2), utils.getTens(value_1)] :
                [value_1, answer, value_2, value_1]
        case '3':
            return settings.show_tens ?
                [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1)] :
                [value_1, value_2, answer, value_1]
        case '4':
            return settings.show_tens ?
                [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_2), answer] :
                [value_1, value_2, value_2, answer]
        default:
            return settings.show_tens ?
                [answer, utils.getTens(value_2), utils.getTens(value_2), utils.getTens(value_1)] :
                [answer, value_2, value_2, value_1]
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/numbersCommutativity.utils.js